module.exports = __webpack_public_path__ + "static/media/school.ac87c5de.png";